import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { ConfigZigbeeEndpoint } from '../components/ConfigZigbeeEndpoint';
import { ZigbeeNodeDescriptor } from '../components/ZigbeeNodeDescriptor';
import { ZigbeeNodeBindingTable } from '../components/ZigbeeNodeBindingTable';
import { ZigbeeNodeNeighbors } from '../components/ZigbeeNodeNeighbors';
import { fetchZigbeeNodeDescriptor } from '../actions/FetchZigbeeNodeDescriptor';
import { fetchZigbeeBindingTable } from '../actions/FetchZigbeeBindingTable';
import { fetchZigbeeNodeNeighbors } from '../actions/FetchZigbeeNodeNeighbors';
import { fetchZigbeeSimpleDescriptors } from '../actions/FetchZigbeeSimpleDescriptors';
import { createZigbeeBinding } from '../actions/CreateZigbeeBinding';
import { deleteZigbeeBinding } from '../actions/DeleteZigbeeBinding';
import { zigbeeNwkAddr } from '../actions/zigbee/commands/ZDP/ZigbeeNwkAddr';
import { ZigbeeNodeInfo } from './config/zigbee/Info';
const FetchNwkAdd = (props) => {
    return (_jsx("form", { onSubmit: props.onSubmit, children: _jsx("button", { type: "submit", children: "Fetch NWK addr" }) }));
};
const FetchSimpleDescriptors = (props) => {
    return (_jsx("form", { onSubmit: props.onSubmit, children: _jsx("button", { type: "submit", children: "Fetch simple descriptors" }) }));
};
export const ConfigZigbeeNode = (props) => {
    const dispatch = useAppDispatch();
    const zigbee_nodes = useAppSelector(state => state.definitions.zigbee_nodes);
    const zigbee_node_descriptors = useAppSelector(state => state.definitions.zigbee_node_descriptors);
    const zigbee_node_neighbors = useAppSelector(state => state.definitions.zigbee_node_neighbors[props.node_id]);
    const binding_table = useAppSelector(state => state.definitions.zigbee_node_binding_table[props.node_id]);
    const node = zigbee_nodes[props.node_id];
    if (node == undefined) {
        return null;
    }
    // old versions don't have ieee_hex. we can phase out usage of node.ieee after a while
    const ieee = node.ieee_hex != null ? node.ieee_hex : (node.ieee == null ? null : (node.ieee.toString(16).padStart(16, '0')));
    const node_descriptor = zigbee_node_descriptors[node.id];
    const node_endpoints = Array.from(Object.keys(node.endpoints).map(s => Number(s)));
    const onFetchNodeDescriptor = (event) => {
        event.preventDefault();
        dispatch(fetchZigbeeNodeDescriptor(node.id));
    };
    const onFetchSimpleDescriptors = (event) => {
        event.preventDefault();
        dispatch(fetchZigbeeSimpleDescriptors(node.id));
    };
    const onFetchNwkAdd = (event) => {
        event.preventDefault();
        dispatch(zigbeeNwkAddr(node.id));
    };
    const onFetchBindingTable = (event) => {
        event.preventDefault();
        dispatch(fetchZigbeeBindingTable(node.id));
    };
    const onFetchNodeNeighbors = (event) => {
        event.preventDefault();
        dispatch(fetchZigbeeNodeNeighbors(node.id));
    };
    const onBind = (btItem) => {
        dispatch(createZigbeeBinding(node.id, btItem));
    };
    const onUnbind = (btItem) => {
        dispatch(deleteZigbeeBinding(node.id, btItem));
    };
    const endpoints = [];
    for (const ep of node_endpoints) {
        endpoints.push(_jsx(ConfigZigbeeEndpoint, { node: props.node_id, endpoint: ep }, props.node_id + '_' + ep));
    }
    return (_jsxs("div", { style: { padding: '10px 10px', borderTop: '3px solid #ddd' }, children: [_jsx(ZigbeeNodeInfo, { node_id: props.node_id }), _jsx(ZigbeeNodeDescriptor, { node_descriptor: node_descriptor, onFetchNodeDescriptor: onFetchNodeDescriptor }), endpoints, _jsx(ZigbeeNodeBindingTable, { bindingtable: binding_table, ieee: ieee, onFetchBindingTable: onFetchBindingTable, onBind: onBind, onUnbind: onUnbind }), _jsx(ZigbeeNodeNeighbors, { neighbors: zigbee_node_neighbors, onFetchNodeNeighbors: onFetchNodeNeighbors }), _jsxs("div", { style: { display: 'flex', justifyContent: 'end', gap: '10px' }, children: [_jsx(FetchNwkAdd, { onSubmit: onFetchNwkAdd }), _jsx(FetchSimpleDescriptors, { onSubmit: onFetchSimpleDescriptors })] })] }, props.node_id));
};
